import { convertServerTimeToUserTime } from 'libs/utils/timezone';

/**
 * Canonical formatter for CANmail scheduled-send times.
 *
 * Scheduled dates are persisted as **Calgary server time** strings
 * (e.g. `"2025-10-08T15:37:00"`), with no timezone marker. Passing one straight
 * to `new Date()` makes the browser interpret it as *local* time, so any user
 * outside Mountain Time sees the wrong hour. Always convert first.
 *
 * This existed as three near-copies (EmailSender, SuccessModal, ConfirmationModal);
 * the ConfirmationModal copy omitted the conversion, so the confirm dialog and the
 * success dialog disagreed about the same scheduled email.
 *
 * @param serverTimeString - Calgary server time, e.g. `"2025-10-08T15:37:00"`.
 * @returns The time in the user's local zone, e.g. `"Oct 8, 2025 3:37 PM"`.
 *          Returns `''` for empty input, or the raw string if it cannot be parsed.
 */
export function formatScheduleDate(serverTimeString?: string | null): string {
  if (!serverTimeString) return '';

  try {
    const userLocalDate = convertServerTimeToUserTime(serverTimeString);

    return userLocalDate.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch (error) {
    console.error('[formatScheduleDate] Failed to format:', serverTimeString, error);
    return serverTimeString; // Fallback to the raw string rather than showing nothing
  }
}

export default formatScheduleDate;
